import { Badge } from './Badge';

export type AppEnvironment = 'dev' | 'staging' | 'production';

export type EnvironmentIndicatorProps = {
  environment: AppEnvironment | undefined;
};

export function EnvironmentIndicator({ environment }: EnvironmentIndicatorProps) {
  if (!environment || environment === 'production') {
    return null;
  }

  const label = environment === 'dev' ? 'DEV' : 'STAGING';
  const variant = environment === 'dev' ? 'default' : 'accent';

  return (
    <div
      className="pointer-events-none fixed bottom-4 right-4 z-[100]"
      aria-hidden="true"
    >
      <Badge variant={variant}>{label}</Badge>
    </div>
  );
}
